import { ORDER } from '../constants';

export const voucherGroupBy = (data = [], needle) => {
  const globalName = 'other';
  let voucherByServiceId = data.reduce((acc, cur) => {
    const key = cur[needle] || globalName;

    acc[key] = key in acc ? [...acc[key], cur] : [cur];

    return acc;
  }, {});

  if (voucherByServiceId[globalName]?.length) {
    Object.keys(voucherByServiceId).forEach(serviceId => {
      if (serviceId !== globalName) {
        voucherByServiceId[serviceId] = [
          ...voucherByServiceId[serviceId],
          ...voucherByServiceId[globalName]
        ];
      }
    });
  }

  return voucherByServiceId;
};

export const getRedemptionType = (
  matrix,
  { productOrderType, hasDevice, planId }
) => {
  const redemption = {};

  for (const type in matrix) {
    const rules = matrix[type].rules;

    for (let i = 0; i < rules.length; i++) {
      const rule = rules[i].validations;
      let mismatch = Object.keys(rules[i].validations).length;

      switch (true) {
        case productOrderType === ORDER.TYPE.NEW &&
          rule.transactionType?.newSignup:
        case productOrderType === ORDER.TYPE.RECON &&
          rule.transactionType?.recontract:
          mismatch -= 1;

          break;

        default:
          break;
      }

      if (rule.withDevice === hasDevice) {
        mismatch -= 1;
      }

      if (rule.plansList?.includes(planId)) {
        mismatch -= 1;
      }

      if (mismatch === 0) {
        redemption[type] = rules[i].redemptionType;
        break;
      }
    }

    if (redemption[type] === undefined) {
      redemption[type] = matrix[type].defaultRedemptionType;
    }
  }

  return redemption;
};
